import { isAdmin } from './isAdmin';
import { isOwner } from './isOwner';
import { isWriter } from './isWriter';
import type { Member } from './types';

/**
 * Owner, admin, or writer only. Ignores custom roles and permission grants — see
 * {@link hasWriterRights} for the looser check, and don't swap one for the other.
 */
export function hasStrictWriterRights(member: Member) {
  return isOwner(member) || isAdmin(member) || isWriter(member);
}
